module.exports = __webpack_public_path__ + "static/media/UF_LOGO.2e433749.png";